import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PublicHeader from '../layout/PublicHeader';
import PublicFooter from '../layout/PublicFooter';
import { SERVER_URL } from '../constants/server-type';
import '../App.css';

export default function ForgotPasswordPage() {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch('${SERVER_URL}/auth/forgot-password', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email })
            });

            if (!response.ok) throw new Error('Request failed');
            setMessage('If an account exists, a reset email has been sent.');
        } catch (err) {
            setMessage('Something went wrong.');
        }
    };

    return (
        <div>
            <PublicHeader />
            <div className="form-container">
                <h2>Forgot Password</h2>
                {message && <p>{message}</p>}
                <form onSubmit={handleSubmit}>
                    <label>Email:</label>
                    <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />

                    <button type="submit">Send Reset Link</button>
                </form>
                <div className="link-buttons">
                    <Link to="/login">Back to Login</Link>
                </div>
            </div>
            <PublicFooter />
        </div>
    );
}
